<template>
  <div class="content-wrapper" :class="{ 'loading-opacity': preloader }">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Designación"
          directory="equipo evaluador"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            :disabled="disabledsupport"
            @click="openDeleteModal"
            v-if="showButton"
          >
            Procesar
          </button>
        </div>
      </div>

      <div class="col-md-12" v-if="showTab"> 
        <app-tab :tabs="tabsHorizontalLab" type="horizontal" />
      </div>
      <div class="col-md-12" v-if="!showTab"> 
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import * as actions from "../../../apiUrl";
import { axiosPatch } from "@/app/helpers/AxiosHelper";
import { axiosGet } from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
export default {
  props: {
    evalTestId: String,
  },
  data() {
    return {
      app_type: "",
      icon: "settings",
      showTab: false,
      tabsHorizontal: [
        {
          icon: "briefcase",
          name: "Equipo Evaluador",
          component: "evaluation-team-designation-info",
          permission: "",
        },
      ],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      showButton: true,
      preloader: false,
      disabledsupport: false,
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview
        ? this.$store.state.evaluatorReview.evalTest
        : null;
    },
  },
  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
    this.getData();
    this.dataAcc();
  },
  methods: {
    returnPage() {
      window.location.href = `/accreditationtechnical/evaluationTeamDesignation`;
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    getData() {
      let url = `/accreditationtechnical/evaluationTeamDesignation/designationReport/show/${this.evalTestId}`;
      axiosGet(url).then((response) => {
       if(response.data.status.code == '400') {
         this.showButton = false;
       }
       
      });
    },
    dataAcc() {
      this.preloader = true;
      let url = `/accreditations/session/showauth/${this.evalTestId}`;
      axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (response?.data) {
              //id session
              axiosGet(
                  `/accreditations/session/getauth`
                )
                  .then((rsession) => {
                    if (rsession.status == 200) {
                      if (response.data.support_technique == rsession.data && response.data.responsible_technician != response.data.support_technique) {
                        this.disabledsupport = true;
                      } else {
                        this.disabledsupport = false;
                      }
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  })
                  .finally(() => {});
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    confirmed() {
      let url = `${actions.TECHNICAL_ANALYSIS_REPORT}/evaluationTeamDesignation/designationReport/process?evalTestId=${this.evalTestId}`;
      this.deleteLoader = true;
      axiosPatch(url)
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
  },
};
</script>
